module.exports = __webpack_public_path__ + "static/media/carrot-logo-mark-white-xmas.4ff5cdc1.png";